module.exports = __webpack_public_path__ + "img/Global-dark.f23f94e5.svg";